import { DateTime } from "luxon";

export const defaultDatePickerMinDate = DateTime.fromISO("2020-01-01");
export const defaultDatePickerMaxDate = DateTime.fromISO("2099-01-01");
